// libs
import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS } from 'shared/styles/base';

// components
import Navigation from 'shared/components/Navigation';

// styles
const Container = styled.div`
  height: calc(100% - 56px);
  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: 56px;
  }

  .reviewCard {
    padding: ${({ theme }) => `${theme.spacing.spacing80} 0 ${theme.spacing.spacing80} 0`};
    margin: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
    border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
    @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
      padding: ${({ theme }) => `${theme.spacing.spacing120} ${theme.spacing.spacing160}`};
      margin: 0;
    }
  }

  .navigation__title {
    ${({ theme }) => theme.typography.titleSmall};
    text-align: center;
  }
`;

interface IWrapperProps {
  children: React.ReactNode;
  isMobile?: boolean;
}

const HeadingLabel = 'All Reviews';

function Wrapper({ children, isMobile = true }: IWrapperProps) {
  const { goBack } = useHistory();

  return (
    <Container data-test="reviewList-container">
      {isMobile && <Navigation title={HeadingLabel} backAction={goBack} />}
      {children}
    </Container>
  );
}

export default memo(Wrapper);
